'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'rotate-right';
var width = 512;
var height = 512;
var aliases = ["redo-alt","rotate-forward"];
var unicode = 'f2f9';
var svgPathData = 'M512-24l0 208-208 0c33.6-33.6 62.4-62.4 86.6-86.6-81.7-69.5-204.5-65.7-281.7 11.5-40.6 40.6-60.9 93.8-60.9 147.1 0 114.9 93.1 208 208 208 83.1 0 154.9-48.7 188.2-119.3l43.4 20.5C446.7 451.9 358.4 512 256 512 114.6 512 0 397.4 0 256 0 190.5 25 125 75 75 170.9-21 324.1-24.8 424.6 63.4 449.4 38.6 478.6 9.4 512-24zM464 91.9l-44.1 44.1 44.1 0 0-44.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRotateRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;